import {Component, OnInit} from '@angular/core';
import {NgForOf, NgIf} from '@angular/common';
import {IconComponent} from '../icon/icon.component';
import {LocalizationService} from '../../../services/localization.service';
import {Icons} from '../../../model/icon';
import {TextsComponent} from '../texts/texts.component';
import {NotificationStyleService} from '../../../services/notification-style-service';
import {NotificationService} from '../../../services/notification-service';
import {NotificationType} from '../../../model/notification';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-toast-notification',
  imports: [
    NgIf,
    IconComponent,
    TextsComponent,
    NgForOf
  ],
  templateUrl: './toast-notification.component.html',
  standalone: true,
  styleUrl: './toast-notification.component.scss'
})
export class ToastNotificationComponent implements OnInit {
  constructor(protected localizationService: LocalizationService,
              protected notificationStyle: NotificationStyleService,
              protected notification: NotificationService,
              protected route: ActivatedRoute,) {}

  toast1: boolean = true;
  toast2: boolean = false;
  languageMenu: boolean = false;

  private readonly TOAST1_STORAGE_KEY = 'Cookies_accepted';

  setLang(id: number){
    this.localizationService.setLanguage(id);
  }

  activeLanguageMenu(){
    this.languageMenu = !this.languageMenu;
  }

  ngOnInit() {
    this.checkToast1State();

    if (window.innerWidth < 769) {
      this.toast1 = false;
    }

    // if (this.toast1) {
    //   setTimeout(() => {
    //     this.toast1 = false;
    //   }, 5000);
    // }
  }

  hideToast1() {
    this.toast1 = false;
    this.saveToast1State();
  }

  private checkToast1State() {
    const savedState = localStorage.getItem(this.TOAST1_STORAGE_KEY);
    if (savedState === 'accepted') {
      this.toast1 = false;
    }
  }

  private saveToast1State() {
    localStorage.setItem(this.TOAST1_STORAGE_KEY, 'accepted');
  }

  getStyle() {
    if (this.notificationStyle.getDocumentStyle() === 1) {
      return true;
    }
    return this.notificationStyle.getActiveStyle() != 0;
  }

  getSystemStyle(style?: NotificationType){
    const stl = style ?? NotificationType.info;
    switch (stl) {
      case NotificationType.success: return 'color: rgba(69, 158, 53);';
      case NotificationType.error: return 'color: rgb(204, 7, 7);';
      case NotificationType.info: return ' color: rgba(0, 85, 255);';
      case NotificationType.warning: return 'color: rgb(217, 192, 69);';
    }
  }

  protected readonly Icons = Icons;
}
